// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageInfo from '../../package.json';
import { AppConfigService } from '../app/tabms/services/app-config.service';

let config: any = {};
export const environment = {
  appVersion: packageInfo.version,
  production: false,
  environmentName: 'dev',
  SignalrHubsUrl: 'https://localhost:44384/signalr-hubs/notification',
  baseUrl: 'https://localhost:44384/api/v1/', 
  baseUrlHR: 'https://dev-hr-api.tab-erp.com/api/v1/',
  baseUrlSS: 'https://dev-selfservices-api.tab-erp.com/',
  baseUrlInv:'https://dev-inventory-api.tab-erp.com/api/v1/',
  baseUrlRE: 'https://dev-renthost.tab-erp.com/api/v1/',
  baseUrlSec: 'https://localhost:44344/api/v1/',
  apiUrl: 'https://localhost:44384/api/', 
  apiUrlHR: 'https://dev-hr-api.tab-erp.com/api/',
  apiUrlSS: 'https://dev-selfservices-api.tab-erp.com/api/',
  apiUrlInv:'https://dev-inventory-api.tab-erp.com/api/',
  apiUrlRE: 'https://dev-renthost.tab-erp.com/api/',
  apiUrlSec: 'https://localhost:44344/api/',
  reportApi: 'https://localhost:44384/api/Viewer/{action}',
  reportDesignerApi:'https://localhost:44384/api/designer',
  filesUrl: 'https://localhost:44384/',  
  issuer: 'https://localhost:44337',
  tokenEndpoint: 'https://localhost:44337/connect/token', 
  redirectUri: 'https://dev-app.tab-erp.com/auth-callback',  
  post_logout_redirect_uri: 'https://dev-app.tab-erp.com',  
  clientId: 'TABMS_Front_Prod', 
  scope:'Adminstration HR AdminRealEstate Inventory SelfServices Secretary'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
